<div class="terms">
  <nav class="legal-nav">
    <a [routerLink]="'/terms-of-use'">Terms of Use</a>
    <a [routerLink]="'/privacy-policy'">Privacy Policy</a>
    <a [routerLink]="'/subscription-terms'" class="active">Subscription Terms</a>
  </nav>

  <h1 class="center"><strong>JustTeach Subscription Terms</strong></h1>
  <p class="center last-updated">Last Updated: January 2026</p>

  <section>
    <h2>1. Free Trial</h2>
    <p>
      We may offer a free trial subscription for service. Unless you cancel at least 24 hours before
      the end of the free trial, you will be automatically charged a price indicated on the payment
      screen for a chosen subscription period.
    </p>
  </section>

  <section>
    <h2>2. Subscription</h2>
    <p>
      The subscription renews automatically at the end of each period (each week, month, 6 months,
      year, or otherwise, depending on the option selected by you at the time of purchase) until you
      cancel.
    </p>
  </section>

  <section>
    <h2>3. Payment Method</h2>
    <p>
      Payment will be charged to the payment method you submitted at the time of purchase at
      confirmation of purchase. You authorize us to charge the applicable subscription fees to the
      payment method that you submit.
    </p>
  </section>

  <section>
    <h2>4. Cancellation</h2>
    <p>
      Canceling your subscription means that the automatic renewal will be disabled, but you will
      still have access to all your subscription features for the remaining time of your
      then-current period. Note that deleting the app does not cancel your subscriptions.
    </p>
    <p>
      If you purchased a subscription or enabled free trial on our website: You can cancel a free
      trial or a subscription by contacting our
      <a target="_blank" href="mailto:justteachsupport@justteach.ai">support</a>
      or by clicking on "Cancel Subscription" button in your account on our website before the end
      of the free trial or then-current subscription period.
    </p>
  </section>

  <section>
    <h2>5. Changes</h2>
    <p>
      To the maximum extent permitted by applicable laws, we may change subscription fees at any
      time. We will give you reasonable notice of any such pricing changes by posting the new prices
      on the app and/or by sending you an email notification, or in other prominent way. If you do
      not wish to pay the new fees, you can cancel the applicable subscription prior to the change
      going into effect.
    </p>
  </section>

  <section>
    <h2>6. Refund Policy</h2>
    <p>
      All subscription fees are non-refundable except as expressly set forth herein or as required
      by applicable law.
    </p>

    <h3>A. Cooling-off Period</h3>
    <p>
      If you are in a jurisdiction that provides for a statutory cooling-off or cancellation period,
      you may cancel your subscription within that period for a full refund.
    </p>

    <h3>B. Requesting a Refund</h3>
    <p>
      To request a refund, please contact our
      <a target="_blank" href="mailto:justteachsupport@justteach.ai">support team</a>
      within 14 days of your purchase with your order details.
    </p>

    <h3>C. Processing Time</h3>
    <p>
      Approved refunds will be processed within 5-10 business days to your original payment method.
    </p>

    <p>
      For additional terms regarding refunds, please refer to our
      <a [routerLink]="'/terms-of-use'">Terms of Use</a>.
    </p>
  </section>

  <section>
    <h2>7. Contact Us</h2>
    <p>
      If you have any questions or concerns about these Subscription Terms, please contact us at:
    </p>
    <div class="contact-info">
      <p><strong>Justspeak ltd</strong></p>
      <p>
        Email:
        <a href="mailto:justteachsupport@justteach.ai">justteachsupport&#64;justteach.ai</a>
      </p>
      <p>Website: <a href="https://justteach.ai">justteach.ai</a></p>
    </div>
    <p>
      Please take a screenshot of this information for your reference. This may help you to control
      your subscriptions.
    </p>
  </section>
</div>
